import { takeEvery } from 'redux-saga/effects';

import * as vehicleActionsTypes from 'store/modules/vehicle/actionTypes';
import { loadTotals } from './utils';

export default function* listenLoadTotals() {
  yield takeEvery(vehicleActionsTypes.LOAD_TOTALS, loadTotals);
}
